(function(){
  function reveal(scope){
    var els=(scope||document).querySelectorAll('.bl-reveal:not(.is-in)');
    if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('is-in')});return;}
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(en){if(en.isIntersecting){en.target.classList.add('is-in');io.unobserve(en.target);}});
    },{rootMargin:'0px 0px -8% 0px',threshold:.08});
    els.forEach(function(e){io.observe(e)});
  }
  /* Garde la miniature active visible dans la rangée de miniatures */
  function followThumbs(scope){
    (scope||document).querySelectorAll('.bl-pdp__thumbs').forEach(function(row){
      if(row.dataset.follow)return;row.dataset.follow='1';
      new MutationObserver(function(){
        var on=row.querySelector('.bl-pdp__thumb.is-on');if(!on)return;
        var left=on.offsetLeft-(row.clientWidth-on.offsetWidth)/2;
        row.scrollTo({left:Math.max(0,left),behavior:'smooth'});
      }).observe(row,{subtree:true,attributes:true,attributeFilter:['class']});
    });
  }
  document.addEventListener('DOMContentLoaded',function(){reveal();followThumbs();});
  document.addEventListener('shopify:section:load',function(e){reveal(e.target);followThumbs(e.target);});

  /* Harmonise les anciens textes de livraison des fiches produit : 5 à 7 jours, offerte dès 20 € */
  function fixShipping(scope){
    var rx=[
      [/\b(?:6|7|8|10)\s*(?:à|-|–)\s*(?:8|9|10|12|14|15)\s*jours(\s*ouvr(?:és|ables))?/gi,'5 à 7 jours'],
      [/((?:à partir de|dès|a partir de)\s*)(?:25|29|30|35|40)\s*(?:€|\$\s*CAD|euros?)/gi,'$120 €'],
      [/(?:30|40)\s*\$\s*CAD/gi,'20 €']
    ];
    var w=document.createTreeWalker(scope||document.body,NodeFilter.SHOW_TEXT,{acceptNode:function(n){
      var t=n.parentNode&&n.parentNode.nodeName;return (t==='SCRIPT'||t==='STYLE'||t==='TEXTAREA')?NodeFilter.FILTER_REJECT:NodeFilter.FILTER_ACCEPT;}});
    var n;while((n=w.nextNode())){var v=n.nodeValue,o=v;rx.forEach(function(r){v=v.replace(r[0],r[1]);});if(v!==o)n.nodeValue=v;}
  }
  document.addEventListener('DOMContentLoaded',function(){if(document.querySelector('.bl-pdp,.product'))fixShipping(document.querySelector('main')||document.body);});

  /* ---------- Cadeaux automatiques dans le panier (paliers) ---------- */
  var GIFTS=[];
  if(window.Shopify&&Shopify.designMode)return;
  var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  var nativeFetch=window.fetch.bind(window),busy=false,again=false,giftVariants=null,timer=null;
  function getGiftVariants(){
    if(giftVariants)return Promise.resolve(giftVariants);
    return Promise.all(GIFTS.map(function(g){
      return nativeFetch(root+'products/'+g.handle+'.js').then(function(r){return r.ok?r.json():null;}).then(function(p){
        var v=p&&p.variants&&p.variants.find(function(x){return x.available;});
        return v?{id:v.id,min:g.min||0,product:g.product||null,qty:g.qty||0}:null;
      }).catch(function(){return null;});
    })).then(function(list){giftVariants=list.filter(Boolean);return giftVariants;});
  }
  function drawer(){return document.querySelector('cart-drawer');}
  function sectionIds(){
    var d=drawer();
    if(d&&typeof d.getSectionsToRender==='function'){return d.getSectionsToRender().map(function(s){return s.id;}).join(',');}
    return 'cart-drawer,cart-icon-bubble';
  }
  function refresh(resp){
    var d=drawer();
    if(d&&resp&&resp.sections&&typeof d.renderContents==='function'&&(d.classList.contains('active')||d.classList.contains('is-open'))){
      try{d.renderContents(resp);return;}catch(e){}
    }
    if(/\/cart\/?$/.test(location.pathname))location.reload();
  }
  function post(url,body){
    return nativeFetch(root+url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)}).then(function(r){return r.json();});
  }
  function sync(){
    if(busy){again=true;return;}
    busy=true;
    getGiftVariants().then(function(gv){
      if(!gv.length)return null;
      return nativeFetch(root+'cart.js').then(function(r){return r.json();}).then(function(cart){
        var giftIds=gv.map(function(g){return g.id;});
        var sub=0;cart.items.forEach(function(it){if(giftIds.indexOf(it.variant_id)<0)sub+=it.final_line_price;});
        var ops=[];
        gv.forEach(function(g){
          var line=cart.items.find(function(it){return it.variant_id===g.id;});
          var want=g.product?cart.items.reduce(function(n,it){return n+(it.handle===g.product?it.quantity:0);},0)>=g.qty:sub>=g.min;
          if(want&&!line)ops.push({type:'add',id:g.id});
          else if(!want&&line)ops.push({type:'set',id:g.id,qty:0});
          else if(want&&line&&line.quantity!==1)ops.push({type:'set',id:g.id,qty:1});
        });
        if(!ops.length)return null;
        var chain=Promise.resolve(null);
        ops.forEach(function(op,i){
          var last=i===ops.length-1,extra=last?{sections:sectionIds(),sections_url:location.pathname}:{};
          chain=chain.then(function(){
            if(op.type==='add')return post('cart/add.js',Object.assign({items:[{id:op.id,quantity:1,properties:{_cadeau:'Offert'}}]},extra));
            return post('cart/change.js',Object.assign({id:String(op.id),quantity:op.qty},extra));
          });
        });
        return chain;
      });
    }).then(function(resp){if(resp)refresh(resp);}).catch(function(){}).then(function(){
      busy=false;if(again){again=false;schedule();}
    });
  }
  function schedule(){clearTimeout(timer);timer=setTimeout(sync,350);}
  window.fetch=function(input,init){
    var url=typeof input==='string'?input:(input&&input.url)||'';
    var p=nativeFetch(input,init);
    if(/\/cart\/(add|change|update|clear)/.test(url)){p.then(function(){schedule();}).catch(function(){});}
    return p;
  };
  document.addEventListener('DOMContentLoaded',schedule);
})();
